<template>
    <el-row>
        <el-form label-width="120px" label-position="left">
                    <el-row :gutter="20">
                <el-col :span="2"><h4>方法归属:</h4></el-col>
                <el-col :span="9" style="margin-top:20px"> 
                   {{methodType[MethodInfo.method_type]?methodType[MethodInfo.method_type].label:''}}
                </el-col>
            </el-row>
            <el-row :gutter="20" class="border">
                <el-col :span="2">
                    <h4>色谱柱:</h4>
                </el-col>
                <el-col :span="22" class="c_margin_top">
                    <el-row style="display:none">
                        <el-col :span="8">
                            <el-form-item label="填料类型:">
                                {{MethodInfo.columnDetail.fillerLabel? MethodInfo.columnDetail.fillerLabel: ''}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="填料粒径:">
                                {{MethodInfo.columnDetail.fillerParticleSize?MethodInfo.columnDetail.fillerParticleSize+'µm':''}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="填料孔径:">
                                {{MethodInfo.columnDetail.aperture?MethodInfo.columnDetail.aperture+'Å':''}}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row style="display:none">
                        <el-col :span="8">
                            <el-form-item label="规格(G):">
                                {{MethodInfo.columnDetail.spec?MethodInfo.columnDetail.spec:''}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="尺寸(D*L):">
                                {{MethodInfo.columnDetail.size?MethodInfo.columnDetail.size:''}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="品牌:">
                                {{MethodInfo.columnDetail.brand?MethodInfo.columnDetail.brand:''}}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="型号:">
                                {{MethodInfo.flashColumn?MethodInfo.flashColumn:''}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="16">
                                <el-form-item label="规格:">
                                    {{MethodInfo.columnDetail.catalogueName}}
                                </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="柱体积:">
                                {{MethodInfo.columnDetail.cv!=''?`${MethodInfo.columnDetail.cv}ml`:MethodInfo.columnDetail.cv}}
                            </el-form-item>
                        </el-col>
                         <el-col :span="8">
                            <el-form-item label="耐压:">
                                {{MethodInfo.columnDetail.pressure!=''?`${MethodInfo.columnDetail.pressure}psi`:MethodInfo.columnDetail.pressure}}
                            </el-form-item>
                        </el-col>
                         <el-col :span="8">
                            <el-form-item label="上样量:">
                                {{MethodInfo.loadAmount}}{{MethodInfo.loadAmountUnit!=undefined||MethodInfo.loadAmountUnit!=""?MethodInfo.loadAmountUnit:'g'}}
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>

             <el-row class="border" :gutter="20">
                <el-col :span="2">
                    <h4>检测设置:</h4>
                </el-col>
                <el-col :span="22" class="c_margin_top">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="监测方法:">
                                {{detectSettingType[MethodInfo.detectSetting]?detectSettingType[MethodInfo.detectSetting].label:''}}
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <el-row v-if="MethodInfo.detectSetting == '0'">
                        <el-col :span="8">
                            <el-form-item label="检测波长1:">
                                {{MethodInfo.wavelengthChA?MethodInfo.wavelengthChA+'nm':''}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="检测波长2:">
                                {{MethodInfo.wavelengthChB?MethodInfo.wavelengthChB+'nm':''}}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="MethodInfo.detectSetting =='1'">
                        <el-col :span="8">
                            <el-form-item label="雾化温度:">
                                {{MethodInfo.atomizationTemperature?MethodInfo.atomizationTemperature+'℃':''}}
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row> 
            <el-row class="border" :gutter="20">
                <el-col :span="2">
                    <h4>馏分收集:</h4>
                </el-col>
                <el-col :span="8" class="c_margin_top" style="margin-top: 9px">
                    <el-form-item label="样品收集:">
                        {{MethodInfo.sampleCollection.collectType!=undefined&&MethodInfo.sampleCollection.collectType!=""?simpleCollectType[MethodInfo.sampleCollection.collectType].label:''}}
                    </el-form-item>
                </el-col>
                <el-col :span="8" class="c_margin_top" style="margin-top: 9px">
                    <el-form-item label="容器收集体积:">
                        {{MethodInfo.sampleCollection.perCollectVol?MethodInfo.sampleCollection.perCollectVol+'ml':''}}
                    </el-form-item>
                </el-col>
            </el-row> 
            <el-row class="border c_margin_top" :gutter="20">
                <el-col :span="2">
                    <h4>洗脱信息:</h4>
                </el-col>
                <el-col :span="22">
                    <el-row class="c_margin_top">
                        <el-form-item label="溶剂:">
                            <el-table :data="MethodInfo.solvents">
                                <el-table-column label="名称" prop="nameCh"></el-table-column>
                                <el-table-column label="管道" prop="channel"></el-table-column>
                                <el-table-column label="极性" prop="polarity"></el-table-column>
                            </el-table>
                        </el-form-item>
                    </el-row>
                    <el-row class="c_margin_top">
                        <el-form-item label="梯度:">
                            <el-row v-if="GradientList.length >0 && GradientList[0].PercentA != ''">
                                <el-table :data="GradientList" max-height="500">
                                    <el-table-column type="index" label="NO."></el-table-column>
                                    <el-table-column label="CV">
                                        <template slot-scope="scope">
                                            <div>     
                                                <div><span style="display: inline-block; width: 40px;">begin</span>{{scope.row.begin_cv}}</div>
                                                <div><span style="display: inline-block; width: 40px;">end</span>{{scope.row.end_cv}}</div>
                                            </div>
                                        </template>  
                                    </el-table-column>
                                    <el-table-column label="Time">
                                        <template slot-scope="scope">
                                            <div>     
                                                <div><span style="display: inline-block; width: 40px;">begin</span>{{scope.row.begin_time}}</div>
                                                <div><span style="display: inline-block; width: 40px;">end</span>{{scope.row.end_time}}</div>
                                            </div>
                                        </template>  
                                    </el-table-column>
                                    <el-table-column label="1st">
                                        <template slot-scope="scope">
                                            <div>{{MethodInfo.solvents.find(item => item.channel === scope.row.channel_1).nameCh}}</div>
                                        </template>  
                                    </el-table-column>
                                    <el-table-column label="2nd">
                                        <template slot-scope="scope">
                                            <div>{{MethodInfo.solvents.find(item => item.channel === scope.row.channel_2).nameCh}}</div>
                                        </template>  
                                    </el-table-column>
                                    <el-table-column label="2nd%">
                                        <template slot-scope="scope">
                                            <div>     
                                                <div><span style="display: inline-block; width: 40px;">begin</span>{{scope.row.begin_percent_2}}</div>
                                                <div><span style="display: inline-block; width: 40px;">end</span>{{scope.row.end_percent_2}}</div>
                                            </div>
                                        </template>  
                                    </el-table-column>
                                    <el-table-column label="3rd" prop="channel_3">
                                        <template slot-scope="scope">
                                            <div v-if="scope.row.channel_3 === ''">{{scope.row.channel_3}}</div>
                                            <div v-else-if="scope.row.channel_3 === 'N'">{{scope.row.channel_3}}</div>
                                            <div v-else-if="scope.row.channel_3 === null">{{""}}</div>
                                            <div v-else>{{MethodInfo.solvents.find(item => item.channel === scope.row.channel_3).nameCh}}</div>
                                        </template> 
                                    </el-table-column>
                                    <el-table-column label="3rd%" prop="percent_3"></el-table-column>
                                    <el-table-column label="flow_rate" prop="flow_rate"></el-table-column>
                                </el-table>
                            </el-row>

                        </el-form-item>

                    </el-row>
                </el-col>

            </el-row>
            <el-row class="border c_margin_top" :gutter="20">
                <el-col :span="2">
                    <h4>其他信息:</h4>
                </el-col>
                <el-col :span="22" class="c_margin_top">
                    <el-row>
                         <el-col :span="8">
                            <el-form-item label="方法名称:">
                                {{MethodInfo.method_name!=''?MethodInfo.method_name:''}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="分离时间(min):">
                                {{MethodInfo.otherInfo!=''?MethodInfo.otherInfo.separateTime:''}}
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-form-item label="溶剂消耗:">
                                <el-row v-if="MethodInfo.otherInfo!=''">
                                <el-table :data="MethodInfo.otherInfo.solventsConsume" v-if="MethodInfo.otherInfo.solventsConsume.length>0" >
                                    <el-table-column label="名称" prop="solvents"></el-table-column>
                                    <el-table-column label="体积(ml)" prop="vol"></el-table-column>
                                </el-table>
                            </el-row>

                        </el-form-item>
                    </el-row>
                    <el-row>
                    <el-col :span="8">
                    <el-form-item label="目标产物:">
                        {{`${MethodInfo.text3!=''?MethodInfo.text3:0}${MethodInfo.yieldUnit!=''?MethodInfo.yieldUnit:'mg'}`}}
                    </el-form-item>
                    </el-col>
                    </el-row>
                    <el-row>
                        <el-form-item label="分离图谱:">
                            <img v-if="Chromatographic!=''" :src="'data:image/png;base64,'+Chromatographic" class="img-size">
                        </el-form-item>
                    </el-row> 
                    <el-row>
                        <el-form-item label="备注:">
                           {{MethodInfo.samplePeakAppearance}}
                        </el-form-item>
                    </el-row> 

                </el-col>
            </el-row>
        </el-form>
    </el-row>
</template>

<script>
// 组件逻辑代码
export default {
        name: "GetMethodInfo",
        data() {
            return {
                processType: this.$store.state.sepaMethods.processType,
                detectSettingType: this.$store.state.sepaMethods.detectSettingType,
                simpleCollectType: this.$store.state.sepaMethods.simpleCollectType,
                gradientType: this.$store.state.sepaMethods.gradientType,
                methodType: this.$store.state.sepaMethods.methodType,
                /**
                 * 流动相、溶剂列表
                 * */
                FlowPhase: this.$store.state.sepaMethods.FlowPhase,
                flowPhaseTags: ['流动相A:','流动相B:','流动相C:'],
                unitOpts: [{
                    label: 'g',
                    value: 'g'
                },{
                    label: 'mg',
                    value: 'mg'
                }],
            }
        },
        props: {
            IsFour: {},
            MethodInfo: {},
            GradientList: {},
            FlowRateList: {},
            Chromatographic: {},
        }
    }

</script>

<style scoped>
/* 组件样式 */
@import "../../../assets/element-component.css";
    .pointBlue{
    background: #107ff1;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin: 6px 7px 0 0;
}
.contentStyle{
    font-size: 17px;
    font-weight: 600;
    box-sizing: border-box;
    padding: 0px 0 0 60px;
}
/* 使用更具体的选择器来覆盖默认样式 */
::v-deep .el-table__header-wrapper tr th {
  background-color: #EBEEF5;;
}
.imgSplit{
    width: 175px;
    height: 138px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 6px 6px 5px 9px;
    border: 1px solid #dcdfe6;
}
</style>